module.exports = __webpack_public_path__ + "img/Frame.f1a66bd5.svg";